import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { get, post } from "../../../components/Utils/CallApi";
import { setError } from "../appSlice";

export const fetchEvents = createAsyncThunk(
  "events/fetchEvents",
  async ({ companyId, page, limit }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `companyId=${companyId}&sectionType=events&page=${page}&limit=${limit}`;
      const response = await get("sections/data/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const getEvent = createAsyncThunk(
  "events/getEvent",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `id=${id}&sectionType=events`;
      const response = await get("sections/data/get", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveEvent = createAsyncThunk(
  "events/saveEvents",
  async (
    { payload, sectionId, files },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "sections/data/save",
        payload,
        state.app,
        sectionId,
        files
      );

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const updateEvent = createAsyncThunk(
  "events/updateEvent",
  async (event, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      // Simulated API call to update an event
      const response = { status: "success", data: event };
      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }
      dispatch(editEvent(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const addEvent = (event) => ({
  type: "events/addEvent",
  payload: event,
});

export const editEvent = (updatedEvent) => ({
  type: "events/editEvent",
  payload: updatedEvent,
});

const eventSlice = createSlice({
  name: "events",
  initialState: {
    eventsList: [],
    loading: false,
    error: null,
  },
  reducers: {
    addEvent: (state, action) => {
      if (action.payload) {
        state.eventsList.push(action.payload);
      }
    },
    editEvent: (state, action) => {
      const index = state.eventsList.findIndex(
        (event) => event.id === action.payload.id
      );
      if (index !== -1) {
        state.eventsList[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.eventsList = action.payload;
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default eventSlice.reducer;
